import AddVideoForm from "../../../components/Admin/Videos/AddVideoForm";
import Navbar from "../../../components/Navbar";

export default function AddVideo() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <AddVideoForm />
        </div>
      </section>
    </>
  );
}
